// OK 05/11/2024

import { FuelCard } from "../interfaces/FuelCard.interface";
import { ObjectId } from "../types";
import {  ip } from "../utils/setup";

const FUELCARD_API = `${ip}/api/CarteCarbus`;

// GET

export async function getFuelCards(): Promise<FuelCard[]> {
    const response = await fetch(FUELCARD_API, {
        credentials: "include" 
    });
  if (response.ok) {
    const body: FuelCard[] = await response.json();
    return body;
  } else {
    return response.json();
  }
}

export async function getFuelCardAlert(): Promise<FuelCard[]> {
    const response = await fetch(`${FUELCARD_API}/CardAlert`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la réception de la carte carburant"
    );
  }
}

// GET ID

export async function getFuelCard(_id: ObjectId): Promise<FuelCard> {
    const response = await fetch(`${FUELCARD_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      "Erreur du serveur lors de la réception de la carte carburant"
    );
  }
}

// POST

export async function createFuelCard(
  newFuelCard: Partial<FuelCard>
): Promise<FuelCard> {
  const response = await fetch(FUELCARD_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(newFuelCard),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      " Erreur lors de la création de la nouvelle carte carburant"
    );
  }
}

//PUT

export async function updateFuelCard(updateFuelCard: FuelCard) {
  const { globalError, ...restFuelCard } = updateFuelCard;
  const response = await fetch(`${FUELCARD_API}/${restFuelCard.idCarte}`, {
      method: "PUT",
      credentials: "include" ,
      headers: {
          "Content-Type": "application/json",
          
      },
    body: JSON.stringify(restFuelCard),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition de la carte carburant");
  }
}

// DELETE

export async function deleteFuelCard(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${FUELCARD_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" 
      
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error("Erreur lors de la suppression de la carte de carburant ");
  }
}
